import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class NodeRedroidScriptFormatter extends Formatter {
}

// Каталог скриптов ЧЕРЕЗ android-сервис, NODE-scoped (App\Models\RedroidScript, is_node=true —
// напр. prepare-farm, authorized/admin/scripts/redroid) — read + редактирование label,
// kind='node'. Device-scoped вариант той же таблицы — см. ApiRedroidScript (devices/redroid-scripts).
export default class ApiNodeRedroidScript extends ApiModelWithAuth {
    pathDef = 'authorized/admin/scripts/redroid';
    formatterItem = NodeRedroidScriptFormatter.Item;
}
